module.exports = __webpack_public_path__ + "static/media/parent-with-toddler-people-svgrepo-com.551099bb.svg";